export default __webpack_public_path__ + "static/media/errorIcon.9ec01ce0.svg";